const STORAGE_PATHS = {
  TIPS: 'tips/'
}

export { STORAGE_PATHS }
export default STORAGE_PATHS
